// extracted by mini-css-extract-plugin
module.exports = {"root":"InnerPageMenu_root__Y4Yj4","marginTop":"InnerPageMenu_marginTop__7zzaF","cardIcon":"InnerPageMenu_cardIcon__jc6z9","downgraded":"InnerPageMenu_downgraded__gedGT"};